module.exports = import("/m43-forms/client/remoteEntry.js");